import user from './server/user/user';
import caregiver from './server/caregiver/caregiver';
import client from './server/client/client';
import ClientOnboardingChat from './server/client/onboarding_chat';
import AssistantChat from './server/client_lead/assistant_chat';
import clientLead from './server/client_lead/client_lead';
import clientSupport from './server/client_support/client_support';
import clientPaymentPlan from './server/client/payment_plan/payment_plan';
import paymentSlip from './server/payment/slip';
import expenseReimbursement from './server/payment/expense_reimbursement';
import fileStorage from './server/file_storage/file_storage';
import communication from './server/communication/communication';

import s3 from './aws/s3';

export default {
  s3,
  user,
  caregiver,
  client,
  ClientOnboardingChat,
  AssistantChat,
  clientLead,
  clientSupport,
  paymentSlip,
  clientPaymentPlan,
  expenseReimbursement,
  fileStorage,
  communication,
};
